import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { LoginHelpOption } from '../../../../flows/login/pages/LoginHelp/LoginHelpOption';
import { MfaType } from '../../../../generic-components/MFA/types';
import Button from '../../../../generic-components/Button';
import { ReactComponent as TextMessage } from '../../../../assets/icons/svg/colored-icons/ic-colored-sms.svg';
import { ReactComponent as PhoneCall } from '../../../../assets/icons/svg/colored-icons/ic-colored-phone-call.svg';

interface IResendCodeWrapperProps {
  isLoading: boolean;
  pendingResendType: MfaType;
  onResendType: (type: MfaType) => void;
  handleResend: () => void;
  handleBack: () => void;
}

export const ResendCodeWrapper = (props: IResendCodeWrapperProps) => {
  const { isLoading, pendingResendType, onResendType, handleResend, handleBack } = props;
  const { t } = useTranslation();
  return (
    <div className='flex flex-col justify-center px-[40px] py-[40px] rounded-[6px] bg-bw00 fadeIn'>
      <Heading
        title={t('ACCOUNTANT_OB.VERIFY_PHONE.RESEND')}
        className='font-metricRMedium text-bw08 mb-[6px] leading-[34px] text-[28px] text-left'
      />
      <Heading
        title={t('ACCOUNTANT_OB.VERIFY_PHONE.RESEND_SUB_HEADER')}
        className='font-metricR text-bw07 text-[16px] mb-[24px] text-left'
      />
      <LoginHelpOption
        title={t('ACCOUNTANT_OB.VERIFY_PHONE.SMS')}
        icon={<TextMessage />}
        onClick={() => onResendType(MfaType.SMS)}
        testId='mfa_method_sms'
        isSelected={pendingResendType === MfaType.SMS}
      />
      <LoginHelpOption
        title={t('ACCOUNTANT_OB.VERIFY_PHONE.PHONE')}
        icon={<PhoneCall />}
        onClick={() => onResendType(MfaType.VOICE)}
        testId='mfa_method_voice'
        isSelected={pendingResendType === MfaType.VOICE}
      />

      <Button
        isLoading={isLoading}
        disable={isLoading}
        onClick={handleResend}
        className='w-full bg-action03 hover:bg-action04 mt-[40px] font-metricRMedium text-bw00 py-[17px] px-[60px] rounded-[4px]'
        title={t('ACCOUNTANT_OB.VERIFY_PHONE.RESEND_CTA')}
        id='resendCode'
      />
      <Button
        disable={isLoading}
        onClick={handleBack}
        className='mt-[14px] font-metricR text-bw07 hover:text-bw08 underline text-[14px]'
        title={t('ACCOUNTANT_OB.VERIFY_PHONE.RESEND_BACK')}
        id='back'
      />
    </div>
  );
};
